/**
 * בניית בקשה ל־GET /api/attractions/rules — חבילה שמורה או יעד בלבד (לפני שמירת הזמנה).
 *
 * @param {{
 *   packageId?: number | string | null,
 *   destinationId?: number | string | null,
 *   packageKey?: string | null,
 *   flightScopeValue?: string | null,
 *   destinationCode?: string | null,
 *   visitDate?: string | null,
 *   limit?: number,
 * }} input
 * @returns {{
 *   mode: 'package' | 'destination' | 'none',
 *   requestParams: Record<string, unknown>,
 *   fetchLinesForPackageId: string | number | null,
 * }}
 */
function normalizeFlightScopeToken(v) {
  if (v == null || v === "") return "";
  const s = String(v).trim().toUpperCase();
  if (s === "ALL") return "";
  if (/^[A-Z]{2,3}$/.test(s)) return s;
  return "";
}

/** @param {unknown} raw */
function normalizePackageRef(raw) {
  if (raw == null || raw === "") return null;
  const st = String(raw).trim();
  if (!st) return null;
  if (
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
      st
    )
  ) {
    return st;
  }
  const n = Number(st);
  if (Number.isFinite(n) && n > 0) return n;
  return st;
}

export function buildAttractionRulesRequestForPackageProfile(input = {}) {
  const limit = input.limit ?? 80;
  const scopeToken = normalizeFlightScopeToken(
    input.flightScopeValue ?? input.destinationCode
  );
  const hasDestinationCode = scopeToken.length >= 2;

  const pkgToken = normalizePackageRef(input.packageId);
  const hasPkg = pkgToken != null;

  const rawDest = input.destinationId;
  const destNum =
    rawDest != null && rawDest !== ""
      ? Number(rawDest)
      : NaN;
  const hasDest = Number.isFinite(destNum) && destNum > 0;

  if (hasPkg) {
    const requestParams = {
      dynamic_package_id: pkgToken,
      limit,
    };
    if (hasDest) requestParams.destination_id = destNum;
    if (input.packageKey) requestParams.package_key = String(input.packageKey);
    if (hasDestinationCode) requestParams.flight_scope_value = scopeToken;
    if (input.visitDate) requestParams.visit_date = String(input.visitDate);
    return {
      mode: "package",
      requestParams,
      fetchLinesForPackageId: pkgToken,
    };
  }

  if (hasDest) {
    const requestParams = {
      destination_id: destNum,
      limit,
    };
    if (input.packageKey) requestParams.package_key = String(input.packageKey);
    if (hasDestinationCode) requestParams.flight_scope_value = scopeToken;
    if (input.visitDate) requestParams.visit_date = String(input.visitDate);
    return {
      mode: "destination",
      requestParams,
      fetchLinesForPackageId: null,
    };
  }

  if (hasDestinationCode) {
    const requestParams = {
      limit,
      flight_scope_value: scopeToken,
    };
    if (input.packageKey) requestParams.package_key = String(input.packageKey);
    if (input.visitDate) requestParams.visit_date = String(input.visitDate);
    return {
      mode: "destination",
      requestParams,
      fetchLinesForPackageId: null,
    };
  }

  return {
    mode: "none",
    requestParams: {},
    fetchLinesForPackageId: null,
  };
}
